/* 
 * Export component file to be used on project
*/

import { Button } from './Button.js';
export default Button;
